import type { IDAChatMessage } from "./chatMessageMapper";

/** Keep every assistant surface following a prompt behind it, in source order. */
export function preserveUserReplyOrder(
  source: IDAChatMessage[],
  ordered: IDAChatMessage[],
): IDAChatMessage[] {
  let result = ordered;
  for (let i = 0; i < source.length; i++) {
    const user = source[i];
    if (user.role !== "user") continue;
    const replies: IDAChatMessage[] = [];
    for (
      let j = i + 1;
      j < source.length && source[j].role === "assistant";
      j++
    ) {
      const reply = result.find((m) => m.id === source[j].id);
      if (reply) replies.push(reply);
    }
    const userIndex = result.findIndex((m) => m.id === user.id);
    if (userIndex < 0 || !replies.length) continue;
    let previousIndex = userIndex;
    const inSourceOrder = replies.every((reply) => {
      const index = result.findIndex((m) => m.id === reply.id);
      const follows = index > previousIndex;
      previousIndex = index;
      return follows;
    });
    if (inSourceOrder) continue;
    const replyIds = new Set(replies.map((reply) => reply.id));
    result = result.filter((message) => !replyIds.has(message.id));
    result.splice(
      result.findIndex((message) => message.id === user.id) + 1,
      0,
      ...replies,
    );
  }
  return result;
}
